export default {
    data() {
        return {
            formInitialised: false,
            errors: {}
        }
    },

    props: {
        formData: {
            type: Object,
        }
    },

    created() {
        this.populateFormData()
            .then(() => {
                this.formInitialised = true;
            });
    },

    mounted() {
        // Add watchers for each form field so that any errors
        // for that field are cleared when its value changes
        _.forEach(this.form, (value, key) => {
            this.$watch(`form.${key}`, function () {
                this.clearErrorFor(key);
            })
        });
    },

    computed: {
        isCreating() {
            return _.isUndefined(this.formData);
        },

        isEditing() {
            return ! this.isCreating;
        }
    },

    methods: {
        /**
         * Submit the form
         * @param method
         * @param url
         * @return {Promise<any>}
         */
        submit(method, url) {
            return new Promise((resolve, reject) => {
                axios[method](url, this.form)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors;
                        reject(errors.response);
                    })
            });
        },

        /**
         * Make a post request
         * @param url
         * @return {*|Promise<any>}
         */
        post(url) {
            return this.submit('post', url);
        },

        /**
         * Make a patch request
         * @param url
         * @return {*|Promise<any>}
         */
        patch(url) {
            return this.submit('patch', url);
        },

        /**
         * Check if the given field has an error
         * @param field
         * @return {boolean}
         */
        hasError(field) {
            return _.has(this.errors, field);
        },

        /**
         * Get the error for the field
         * @param field
         */
        getErrorFor(field) {
            return this.hasError(field) ? this.errors[field][0] : '';
        },

        /**
         * Clear the errors for the given field
         * @param field
         */
        clearErrorFor(field) {
            this.$delete(this.errors, field);
        },

        /**
         * If form data has been provided, populate the form with it
         * @returns {Promise<unknown>}
         */
        populateFormData() {
            return new Promise(resolve => {
                _.forEach(this.formData, (value, key) => {
                    if (_.has(this.form, key)) {
                        this.form[key] = value;
                    }
                });

                resolve();
            });
        },

        submitForm(redirect=true) {
            if (! this.baseUrl) {
                return console.error('Base URL not set for form. Please set in data.');
            }

            if (this.isCreating) {
                return new Promise((resolve, reject) => {
                    this.createItem(redirect)
                        .then(response => {
                            resolve(response);
                        })
                        .catch(() => {
                            reject();
                        })
                });
            }

            return new Promise((resolve, reject) => {
                this.updateItem()
                    .then(response => {
                        resolve(response);
                    })
                    .catch(() => {
                        reject();
                    })
            });
        },

        createItem(redirect = true) {
            return new Promise((resolve, reject) => {
                this.post(this.baseUrl)
                    .then(response => {
                        if (redirect) {
                            window.location = `${this.baseUrl}/${response.data.id}/edit`;
                        }

                        resolve(response);
                    })
                    .catch(() => {
                        createToast('Creation Failed', null, false);
                        reject();
                    });
            });
        },

        updateItem() {
            return new Promise((resolve, reject) => {
                this.patch(`${this.baseUrl}/${this.formData.id}`)
                    .then(response => {
                        createToast('Update Successful');
                        resolve(response);
                    })
                    .catch(() => {
                        createToast('Update Failed', null, false);
                        reject();
                    });
            })

        },

        deleteItem() {
            axios.delete(`${this.baseUrl}/${this.formData.id}`)
                .then(() => {
                    window.location = this.baseUrl;
                });
        }
    }
}
